import React, { createContext, useContext, useMemo, useState } from 'react';

const CitaContext = createContext(null);

export function CitaProvider({ children }) {
  const [cita, setCita] = useState(null);

  const clearCita = () => setCita(null);

  const value = useMemo(() => ({ cita, setCita, clearCita }), [cita]);

  return (
    <CitaContext.Provider value={value}>
      {children}
    </CitaContext.Provider>
  );
}

export function useCita() {
  const ctx = useContext(CitaContext);
  if (!ctx) {
    throw new Error('useCita debe usarse dentro de CitaProvider');
  }
  return ctx;
}